export const PLANS = {
  'fl-monthly-3999': {
    name: 'fl-monthly-3999',
    price: 39.99,
    periodPrice: 39.99,
    description: 'one month',
    disclaimer: 'monthly',
    productId: '1 month - $39.99',
    duration: '1 month',
  },
  'fl-3month-5999': {
    name: 'fl-3month-5999',
    price: 59.99,
    periodPrice: 59.99,
    description: 'three months',
    disclaimer: 'quarterly',
    productId: '3 months - $59.99',
    duration: '3 months',
  },
  'fl-6month-7176': {
    name: 'fl-6month-7176',
    price: 71.76,
    periodPrice: 71.76,
    description: 'six months',
    disclaimer: 'semi_annually',
    productId: '6 months - $71.76',
    duration: '6 months',
  },
  'fl-monthly-intro7d-699-3999': {
    name: 'fl-monthly-intro7d-699-3999',
    price: 39.99,
    periodPrice: 6.99,
    description: 'one month',
    disclaimer: 'monthly',
    productId: '1 month - $39.99',
    duration: '1 month',
  },
  // bravo plans
  'fl-6month-6999': {
    name: 'fl-6month-3999',
    price: 69.99,
    periodPrice: 69.99,
    description: 'six months',
    disclaimer: 'semi_annually',
    productId: '6 months - $69.99',
    duration: '6 months',
  },

  // alfa & alfa 2 plans
  'fl-1-month-tomato': {
    name: 'fl-1-month-tomato',
    price: 19.96,
    periodPrice: 19.96,
    description: 'one month',
    disclaimer: 'monthly',
    productId: '1 month - $19.96',
    duration: '1 month',
  },
  'fl-3month-2999': {
    name: 'fl-3month-2999',
    price: 29.99,
    periodPrice: 29.99,
    description: 'three months',
    disclaimer: 'quarterly',
    productId: '3 months - $29.99',
    duration: '3 months',
  },
  'fl-6month-3999': {
    name: 'fl-6month-3999',
    price: 39.99,
    periodPrice: 39.99,
    description: 'six months',
    disclaimer: 'semi_annually',
    productId: '6 months - $39.99',
    duration: '6 months',
  },
  'fl-monthly-2999': {
    name: 'fl-monthly-2999',
    price: 29.99,
    periodPrice: 29.99,
    description: 'one month',
    disclaimer: 'monthly',
    productId: '1 month - $29.99',
    duration: '1 month',
  },
  'fl-6month-4999': {
    name: 'fl-6month-4999',
    price: 49.99,
    periodPrice: 49.99,
    description: 'six months',
    disclaimer: 'semi_annually',
    productId: '6 months - $49.99',
    duration: '6 months',
  },

  // expensive & cheap plans
  'fl-3month-intro7d-999-7999': {
    name: 'fl-3month-intro7d-999-7999',
    price: 79.99,
    periodPrice: 0.99,
    description: 'three months',
    disclaimer: 'quarterly',
    productId: '3 months - $79.99',
    duration: '3 months',
  },
  'fl-3month-intro7d-999-4999': {
    name: 'fl-3month-intro7d-999-4999',
    price: 49.99,
    periodPrice: 0.99,
    description: 'three months',
    disclaimer: 'quarterly',
    productId: '3 months - $49.99',
    duration: '3 months',
  },
  'fl-3month-6399': {
    name: "fl-3month-6399",
    price: 63.99,
    periodPrice: 63.99,
    description: 'three months',
    disclaimer: 'quarterly',
    productId: '3 months - $63.99',
    duration: '3 months',
  },
  'fl-3month-7999': {
    name: "fl-3month-7999",
    price: 79.99,
    periodPrice: 79.99,
    description: 'three months',
    disclaimer: 'quarterly',
    productId: '3 months - $79.99',
    duration: '3 months',
  },
  'fl-3month-3999': {
    name: 'fl-3month-3999',
    price: 39.99,
    periodPrice: 39.99,
    description: 'three months',
    disclaimer: 'quarterly',
    productId: '3 months - $39.99',
    duration: '3 months',
  },
  'fl-3month-4999': {
    name: 'fl-3month-4999',
    price: 49.99,
    periodPrice: 49.99,
    description: 'three months',
    disclaimer: 'quarterly',
    productId: '3 months - $49.99',
    duration: '3 months',
  },

  // euro plans
  'fl-monthly-3999-eur': {
    name: 'fl-monthly-3999-eur',
    price: 39.99,
    periodPrice: 39.99,
    description: 'one month',
    disclaimer: 'monthly',
    productId: '1 month - €39.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3month-5999-eur': {
    name: 'fl-3month-5999-eur',
    price: 59.99,
    periodPrice: 59.99,
    description: 'three months',
    disclaimer: 'quarterly',
    productId: '3 months - €59.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-intro7d-699-3999-eur': {
    name: 'fl-monthly-intro7d-699-3999-eur',
    price: 39.99,
    periodPrice: 6.99,
    description: 'one month',
    disclaimer: 'monthly',
    productId: '1 month - €39.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },

  // upsell plans
  'fl-3month-upsell-1999': {
    name: 'fl-3month-upsell-1999',
    price: 19.99,
    periodPrice: 19.99,
    description: '3 months upsell',
    disclaimer: 'quarterly',
    productId: '3 months - upsell $19.99',
    duration: '3 months',
  },
  'fl-3month-upsell-1799': {
    name: 'fl-3month-upsell-1799',
    price: 17.99,
    periodPrice: 17.99,
    description: '3 months upsell',
    disclaimer: 'quarterly',
    productId: '3 months - upsell $17.99',
    duration: '3 months',
  },
  'fl-3month-upsell-1599': {
    name: 'fl-3month-upsell-1599',
    price: 15.99,
    periodPrice: 15.99,
    description: '3 months upsell',
    disclaimer: 'quarterly',
    productId: '3 months - upsell $15.99',
    duration: '3 months',
  },
  'fl-3month-upsell-1499': {
    name: 'fl-3month-upsell-1499',
    price: 14.99,
    periodPrice: 14.99,
    description: '3 months upsell',
    disclaimer: 'quarterly',
    productId: '3 months - upsell $14.99',
    duration: '3 months',
  },
  'fl-3month-upsell-1349': {
    name: 'fl-3month-upsell-1349',
    price: 13.49,
    periodPrice: 13.49,
    description: '3 months upsell',
    disclaimer: 'quarterly',
    productId: '3 months - upsell $13.49',
    duration: '3 months',
  },
  'fl-3month-upsell-1199': {
    name: 'fl-3month-upsell-1199',
    price: 11.99,
    periodPrice: 11.99,
    description: '3 months upsell',
    disclaimer: 'quarterly',
    productId: '3 months - upsell $11.99',
    duration: '3 months',
  },
  'fl-3month-upsell-449': {
    name: 'fl-3month-upsell-449',
    price: 4.49,
    periodPrice: 4.49,
    description: '3 months upsell',
    disclaimer: 'quarterly',
    productId: '3 months - upsell $4.49',
    duration: '3 months',
  },
  'fl-3month-upsell-599': {
    name: 'fl-3month-upsell-599',
    price: 5.99,
    periodPrice: 5.99,
    description: '3 months upsell',
    disclaimer: 'quarterly',
    productId: '3 months - upsell $5.99',
    duration: '3 months',
  },
  'fl-3month-upsell-749': {
    name: 'fl-3month-upsell-749',
    price: 7.49,
    periodPrice: 7.49,
    description: '3 months upsell',
    disclaimer: 'quarterly',
    productId: '3 months - upsell $7.49',
    duration: '3 months',
  },
  'fl-3month-upsell-799': {
    name: 'fl-3month-upsell-799',
    price: 7.99,
    periodPrice: 7.99,
    description: '3 months upsell',
    disclaimer: 'quarterly',
    productId: '3 months - upsell $7.99',
    duration: '3 months',
  },
  'fl-3month-upsell-999': {
    name: 'fl-3month-upsell-999',
    price: 9.99,
    periodPrice: 9.99,
    description: '3 months upsell',
    disclaimer: 'quarterly',
    productId: '3 months - upsell $9.99',
    duration: '3 months',
  },
  'fl-monthly-upsell-599': {
    name: 'fl-monthly-upsell-599',
    price: 5.99,
    periodPrice: 5.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    productId: '1 month - upsell $5.99',
    duration: '1 month',
  },
  'fl-monthly-upsell-799': {
    name: 'fl-monthly-upsell-799',
    price: 7.99,
    periodPrice: 7.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    productId: '1 month - upsell $7.99',
    duration: '1 month',
  },
  'fl-monthly-upsell-999': {
    name: 'fl-monthly-upsell-999',
    price: 9.99,
    periodPrice: 9.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    productId: '1 month - upsell $9.99',
    duration: '1 month',
  },
  'fl-monthly-upsell-599-eur': {
    name: 'fl-monthly-upsell-599-eur',
    price: 5.99,
    periodPrice: 5.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    productId: '1 month - upsell €5.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-upsell-799-eur': {
    name: 'fl-monthly-upsell-799-eur',
    price: 7.99,
    periodPrice: 7.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    productId: '1 month - upsell €7.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-monthly-upsell-999-eur': {
    name: 'fl-monthly-upsell-999-eur',
    price: 9.99,
    periodPrice: 9.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    productId: '1 month - upsell €9.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3month-upsell-599-eur': {
    name: 'fl-3month-upsell-599-eur',
    price: 5.99,
    periodPrice: 5.99,
    description: '3 months upsell',
    disclaimer: 'quarterly',
    productId: '3 months - upsell €5.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3month-upsell-799-eur': {
    name: 'fl-3month-upsell-799-eur',
    price: 7.99,
    periodPrice: 7.99,
    description: '3 months upsell',
    disclaimer: 'quarterly',
    productId: '3 months - upsell €7.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-3month-upsell-999-eur': {
    name: 'fl-3month-upsell-999-eur',
    price: 9.99,
    periodPrice: 9.99,
    description: '3 months upsell',
    disclaimer: 'quarterly',
    productId: '3 months - upsell €9.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-6month-upsell-599-eur': {
    name: 'fl-6month-upsell-599-eur',
    price: 5.99,
    periodPrice: 5.99,
    description: '6 month upsell',
    disclaimer: 'semi_annually',
    productId: '6 month - upsell €5.99',
    duration: '6 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-6month-upsell-799-eur': {
    name: 'fl-6month-upsell-799-eur',
    price: 7.99,
    periodPrice: 7.99,
    description: '6 month upsell',
    disclaimer: 'semi_annually',
    productId: '6 month - upsell €7.99',
    duration: '6 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fl-6month-upsell-999-eur': {
    name: 'fl-6month-upsell-999-eur',
    price: 9.99,
    periodPrice: 9.99,
    description: '6 month upsell',
    disclaimer: 'semi_annually',
    productId: '6 month - upsell €9.99',
    duration: '6 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
}